export default __webpack_public_path__ + "static/media/capgue.ca630515.png";